import * as React from 'react';
import {URL_HELPER} from "../App";

export const RegionSelector = () => {

    const searchParam = "?region=";

    function isSelected(key: string) {
        return key === window.location.search.replace(searchParam, "");
    }

    const renderOptions = () => {
        let regions = URL_HELPER.getRegions();

        if (!regions || regions.length <= 1) {
            return "";
        }

        return (regions.map((region) => {
            if (isSelected(region.key)) {
                return <div className="btn btn-secondary" key={region.key}>{region.name}</div>;
            } else {
                return <a className="btn btn-ghost p-2" href={"?region=" + region.key} key={region.key}>{region.name}</a>;
            }
        }));
    };


    return (
        <div className="region-select">
            <div>{renderOptions()}</div>
        </div>
    );
};
export default RegionSelector;
